import { createSlice } from '@reduxjs/toolkit';
import { problemDomainPages } from './problemDomainPages';

const isValidProductWorld = (world) => world != null && !Number.isNaN(world);

const initialState = {
  page: problemDomainPages.domainSelectionPage,
  selectedWorld: null,
  selectedSubscription: null,
  selectedDomainContentLinkId: null,
  detectedFaultResult: null,
  skippedSubscriptionSelection: false,
};

const problemDomainBlockSlice = createSlice({
  name: 'problemDomainBlock',
  initialState,
  reducers: {
    goToDomainSelection: (state) => {
      state.page = problemDomainPages.domainSelectionPage;
      state.selectedWorld = null;
      state.selectedSubscription = null;
      state.selectedDomainContentLinkId = null;
      state.detectedFaultResult = null;
      state.skippedSubscriptionSelection = false;
    },
    goToSubscriptionSelection: (state, action) => {
      const { world, domainContentLinkId } = action.payload;
      if (!isValidProductWorld(world)) {
        return;
      }
      state.page = problemDomainPages.subscriptionSelectionPage;
      state.selectedWorld = world;
      state.selectedDomainContentLinkId = domainContentLinkId ?? null;
      state.selectedSubscription = null;
      state.detectedFaultResult = null;
      state.skippedSubscriptionSelection = false;
    },
    selectSubscription: (state, action) => {
      const isWrapped = action.payload && Object.prototype.hasOwnProperty.call(action.payload, 'subscription');
      state.selectedSubscription = isWrapped ? action.payload.subscription : action.payload;
      state.skippedSubscriptionSelection = isWrapped
        ? Boolean(action.payload.skippedSelection)
        : false;
      state.detectedFaultResult = null;
      state.page = problemDomainPages.scanningPage;
    },
    goBackToSubscriptionSelection: (state) => {
      state.selectedSubscription = null;
      state.detectedFaultResult = null;
      state.skippedSubscriptionSelection = false;
      state.page = problemDomainPages.subscriptionSelectionPage;
    },
    goToDetectedFaultPage: (state, action) => {
      state.detectedFaultResult = action.payload ?? null;
      state.page = problemDomainPages.detectedFaultPage;
    },
    goToUnidentifiedFaultPage: (state) => {
      state.detectedFaultResult = null;
      state.page = problemDomainPages.unidentifiedFaultPage;
    },
    resetProblemDomainFlow: () => initialState,
    reportDWH: (state, action) => {},
  },
});

export const {
  goToDomainSelection,
  goToSubscriptionSelection,
  selectSubscription,
  goBackToSubscriptionSelection,
  goToDetectedFaultPage,
  goToUnidentifiedFaultPage,
  resetProblemDomainFlow,
  reportDWH,
} = problemDomainBlockSlice.actions;

export default problemDomainBlockSlice.reducer;
